import { isUserLoggedIn, useUser } from '~/modules/user';
import type { ReactElement } from 'react';
import { cloneElement } from 'react';
import { useAuth } from '~/modules/root/context';

interface BoardActionWithLoginPromptProps {
    action: ReactElement<{ onClick: () => void }>;
    customRedirect?: string;
}

const BoardActionWithLoginPrompt = ({
    action,
    customRedirect,
}: BoardActionWithLoginPromptProps) => {
    const user = useUser();
    const isLoggedIn = isUserLoggedIn(user);
    const { showAuthModal } = useAuth();

    const authoriseClick = () => {
        if (isLoggedIn) {
            action.props.onClick();
        } else {
            showAuthModal({
                authSource: 'designBoard',
                redirect: customRedirect,
            });
        }
    };

    const toggle = cloneElement(action, { onClick: authoriseClick });

    return toggle;
};

export default BoardActionWithLoginPrompt;
